<template>
    <router-view v-slot="{ Component }">
        <transition name="page">
            <component :is="Component" />
        </transition>
    </router-view>
</template>

<script setup lang="ts">
/*
    Organization / ordering applied:
    1. Imports
    2. Props / Emits
    3. Constants
    4. Stores & top-level services
    5. Reactive state (refs/reactive)
    6. Validation rules & setup
    7. Computed
    8. Handlers / methods
    9. Helpers / lifecycle
*/

// 1. Imports
// (none)

// 2. Props / Emits
// (none)

// 3. Constants
// (none)

// 4. Stores & top-level services
// (none)

// 5. Reactive state (refs/reactive)
// (none)

// 6. Validation rules & setup
defineOptions({
    name: 'ShipmentsShippingLabelsIndex'
})

// 7. Computed
// (none)

// 8. Handlers / methods
// (none)

// 9. Helpers / lifecycle
// (none)
</script>
